import React, { useEffect, useState } from "react";
import { corefetch } from "../../../Util/axios_core_helper";

export const FAQFront = () => {
  const [faqs, setFaqs] = useState([]);

  // Fetch FAQ data from back office (Code 2)
  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const data = await corefetch("Faq/GetFaq"); // API call to fetch FAQs
        setFaqs(data); // Store fetched FAQs in state
      } catch (error) {
        console.error("Error fetching FAQ data:", error);
      }
    };

    fetchFaqs(); // Fetch FAQ data when the component mounts
  }, []); // Empty dependency array to run only once

  return (
    <div>
      <div className="page-wrapper">
        <section className="wpo-page-title">
          <div className="container">
            <div className="row">
              <div className="col col-xs-12">
                <div className="wpo-breadcumb-wrap">
                  <h2>FAQ</h2>
                  <ol className="wpo-breadcumb-wrap">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>FAQ</li>
                  </ol>
                </div>
              </div>
            </div>{" "}
            {/* end row */}
          </div>{" "}
          {/* end container */}
        </section>

        {/* Display FAQs */}
        <br />
        <div>
          {faqs.length > 0 ? (
            faqs.map((faq) => (
              <details key={faq.faqID}>
                <summary className="summary-text">
                  {faq.question} {/* Display the question */}
                  <div className="control-icon control-icon-expand">
                    <i
                      style={{ fontSize: "20PX" }}
                      className="fa fa-angle-down"
                    ></i>
                  </div>
                  <div className="control-icon control-icon-close">
                    <i
                      style={{ fontSize: "20PX" }}
                      className="fa fa-angle-up"
                    ></i>
                  </div>
                </summary>
                <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                {/* Display the answer */}
              </details>
            ))
          ) : (
            <div className="NOFAQ">
              <p>No FAQs available</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
